import React, { useState, useEffect } from "react";
import Cropper from "react-easy-crop";
import Popup from "./Popup";
import { IPopupProps } from "../Common/types";
import PicturesCrop from "../Common/PictureLoader/PicturesCrop";
import Dropzone from 'react-dropzone'
import Loading from "../Ui/Loading";

type props = {
    head?: { title: string, description?: string };
    maxSize?: number;
    getPicture: (picture: any) => any;
    children?: any;
} 

const oneMb = 1048576; 
//const validTypes = ["png", "jpeg"]

const PictureCropPopup = ({ head, getPicture, maxSize, children }: props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [picture, setPicture] = useState(null);
    const [error, setError] = useState(null);
    const [maxSizeB, setMaxSizeB] = useState(2097152); //2Mb default

    useEffect(() => {
        if (maxSize) setMaxSizeB(maxSize * oneMb);
    }, [])


    const handleFile = (file) => {
        setError(null);
        if (file[0].size > maxSizeB) return setError(`Размер файла не должен прeвышать ${maxSizeB / oneMb} МБ`);
        //if (!file[0]?.type || !validTypes.some(type => file[0].type.split("/")[1].includes(type))) return setError("Недопустимое расширение файла");

        setPicture(new File([file[0]], file[0].name, { type: file[0].type }));
    }

    const sendPicture = (pic) => {
        console.log(pic);

        setIsOpen(false);
        getPicture(pic);
        setPicture(null);
    }

    const renderBody = () => {
        if (!picture) return (
            <div className="defaultDropZone">
                <Dropzone
                    onDrop={handleFile}
                    maxSize={maxSizeB}
                >
                    {({ getRootProps, getInputProps }) => (
                        <div className="defaultDropZoneButton"
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} />
                            <img src="../../main-images/dropZoneIcon.svg"></img>
                        </div>
                    )}
                </Dropzone>

                <p className="dropZoneRules">
                    Максимальный размер файла не более {maxSizeB / oneMb} Мб
                    {/*<br></br>*/}
                    {/*Допустимые расширения: .png, .jpeg*/}
                </p>
                {error &&
                    <p className="errorText">{error}</p>    
                }
            </div>
        )

        if (picture) return (
            <PicturesCrop
                img={picture}
                uploadImage={sendPicture}
                setCropActive={(bool) => { setPicture(null) }}
                setButtonText={"Подтвердить"}
            />
        )
    }

    return (
        <>
            {children && <div onClick={() => setIsOpen(true)}>{children}</div>}

            <Popup
                isOpen={isOpen}
                head={head || { title: "Загрузите изображение" }}
                close={() => setIsOpen(false)}
                body={renderBody()}
            />
        </>
    );
}

export default PictureCropPopup;